import { render, staticRenderFns } from "./BDXStatusPendingManager.vue?vue&type=template&id=370838de&scoped=true"
import script from "./BDXStatusPendingManager.vue?vue&type=script&lang=js"
export * from "./BDXStatusPendingManager.vue?vue&type=script&lang=js"
import style0 from "./BDXStatusPendingManager.vue?vue&type=style&index=0&id=370838de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370838de",
  null
  
)

export default component.exports